




















































































import { Component, Mixins, Prop } from 'vue-property-decorator'
import ItDateInput from '@/components/itrack/ItDateInput.vue'
import { MixinMember } from '@/components/mixins/MixinMember'
import {getResponsavel, ItrackCollection} from '@/helpers'
import ClientNotificationRequest from '@/model/request/ClientNotificationRequest'
import { IResource } from 'simpli-web-sdk'

@Component({components: {ItDateInput}})
export default class FilterClientNotification extends Mixins(MixinMember) {
  @Prop({required: true}) value!: ClientNotificationRequest

  searchByCTEEvent(item: IResource, cache: IResource[]) {
    this.value.populateSearchByCTE(cache)
  }

  allDocsEvent(item: IResource, cache: IResource[]) {
    this.value.populateAllDocs(cache)
  }

  cleanSearchByCtes() {
    this.value.cleanSearchByCTE()
  }
}
